import moment from "moment-timezone";

/**
 * サロンの営業時間・予約時刻はすべて日本時間で扱う。
 *
 * moment-timezone は moment 本体を require して patch し、同じインスタンスを返す
 * （moment-timezone 0.5.48: moment-timezone.js:12 `factory(require('moment'))` と factory 末尾の
 *  `return moment;`。setDefault の実体は同 :707 で moment 本体の defaultZone を書き換える）。
 * このため、ここで setDefault しておくと素の `import moment from 'moment'` をしている
 * src/api/api.ts:2 と src/store/actions.ts:3 にも効く。
 * これを外すと、海外のブラウザで予約時刻が現地時間として表示・計算されてしまう。
 */
export const SALON_TZ = "Asia/Tokyo";

moment.tz.setDefault(SALON_TZ);
